import { render, staticRenderFns } from "./Burger.vue?vue&type=template&id=f2844b5c&"
import script from "./Burger.vue?vue&type=script&lang=js&"
export * from "./Burger.vue?vue&type=script&lang=js&"
import style0 from "./Burger.vue?vue&type=style&index=0&id=f2844b5c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports